/**
 * Primary display languages for the countries currently supported by the
 * localized money experience. The region always comes from the account, not
 * the browser, so a US account consistently sees `$74.73` even when the device
 * language is Romanian, German, or French.
 */
const countryLanguageMap: Readonly<Record<string, string>> = {
  AL: 'sq',
  AT: 'de',
  AU: 'en',
  BA: 'bs',
  BE: 'nl',
  BG: 'bg',
  BY: 'be',
  CA: 'en',
  CH: 'de',
  CY: 'el',
  CZ: 'cs',
  DE: 'de',
  DK: 'da',
  EE: 'et',
  ES: 'es',
  FI: 'fi',
  FR: 'fr',
  GB: 'en',
  GR: 'el',
  HR: 'hr',
  HU: 'hu',
  IE: 'en',
  IS: 'is',
  IT: 'it',
  LI: 'de',
  LT: 'lt',
  LU: 'fr',
  LV: 'lv',
  MC: 'fr',
  MD: 'ro',
  ME: 'sr',
  MK: 'mk',
  MT: 'mt',
  NL: 'nl',
  NO: 'nb',
  PL: 'pl',
  PT: 'pt',
  RO: 'ro',
  RS: 'sr',
  RU: 'ru',
  SE: 'sv',
  SI: 'sl',
  SK: 'sk',
  SM: 'it',
  UA: 'uk',
  US: 'en',
  VA: 'it',
};

export function getLocale(countryCode: string): string {
  const upperCode = countryCode.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(upperCode)) {
    return 'en-US';
  }

  const language = countryLanguageMap[upperCode] || 'en';
  return `${language}-${upperCode}`;
}
